export default __webpack_public_path__ + "static/media/icon-role-Domain.1370ea9f.svg";